// Queries
import customer from "./CustomerQuery.gql";

export const Query = {
    customer,
};
